//
import Model from '@/models/Model'

/**
 * @class
 */
export default class SlSaleDebitNote extends Model {

    //
    static includes = [
        'sl_customer',
    ]

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get sl_customer_business_name () {
        return this.getProperty('sl_customer.business_name', '-')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get sl_sale_invoice_customer_business_name () {
        return this.getProperty('sl_sale_invoice.sl_customer.business_name', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get sl_sale_invoice_total() {
        return this.getProperty('sl_sale_invoice.total', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get was_replaced_str() {
        return this.getProperty('was_replaced', false) ? 'Si' : 'No'
    }

    /* 
     */
    get typeDocumentReference() {
        if(this.sl_sale_invoice_id){
            return "FACTURA ELECTRÓNICA"
        }
        else if(this.sl_sale_credit_note_id){
            return "NOTA DE CRÉDITO"
        }
        else if(this.sl_sale_ticket_id){
            return "BOLETA"
        }
        else{
            return ""
        }
    }

    /**
     * 
     */
    resource() {
        return 'sl_sale_debit_note'
    }

    /**
     * 
     */
    toCreate() {
        return this.clean([
            'type_reference_document',
            'dte_number',
            'reason',
            'total_amount',
        ])
     }
}